module.exports = __webpack_public_path__ + "assets/img/bp_d_i_1.daef1e1b.jpg";